import React, { useState, useEffect } from "react"

import Button from "../Button/Button"

import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone"

import RoomIcon from "@material-ui/icons/Room"

import FacebookIcon from "@material-ui/icons/Facebook"

import LinkedInIcon from "@material-ui/icons/LinkedIn"

import EmailIcon from "@material-ui/icons/Email"

import appstore from "../../assets/images/app_store.svg"
import googleplay from "../../assets/images/play_store.svg"
import microsoft from "../../assets/images/microsoft_store.svg"

import HubspotForm from "./HubspotForm"

import { makeStyles } from "@material-ui/core/styles"
import Modal from "@material-ui/core/Modal"
import DialogContent from "@material-ui/core/DialogContent"

import Backdrop from "@material-ui/core/Backdrop"
import Fade from "@material-ui/core/Fade"

import "./footer.scss"

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#A0A0A0",
    color: "white",
    border: "0px",
    borderRadius: "5px",
    maxWidth: "300px",
    width: "100%",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}))

function getWindowDimensions() {
  if (typeof window !== "undefined") {
    const { innerWidth: width, innerHeight: height } = window
    return {
      width,
      height,
    }
  } else {
    return {
      width: 0,
      height: 0,
    }
  }
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  )

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return windowDimensions
}

const Footer = (props) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const { height, width } = useWindowDimensions()


  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const { footer } = props

  return (
    <div className="footer">
      {footer ? (
        <>
          <div className="impresszum">
            <div>{footer.text_prodhost}</div>
            <div>{footer.text_all_rights}</div>
          </div>
          <div className="aszf-wrapper">
            <div className="aszf">
              <a href={"aszf.pdf"} download>
                {footer.text_aszf}
              </a>
            </div>
            <div className="adatvedelmi">
              <a href={"adatkezelesi_tajekoztato.pdf"} download>
                {footer.text_adatvedelmi}
              </a>
            </div>
          </div>
          <div className={"hirlevel_button"}>
            <div className="downloads-wrapper">
              <a
                href={"https://apps.apple.com/"}
                rel={"noopener noreferrer"}
                target={"_blank"}
                aria-label={"appstore"}
              >
                <img src={appstore} alt="appstore_logo" />
              </a>
              <a
                href={"https://play.google.com/"}
                rel={"noopener noreferrer"}
                target={"_blank"}
                aria-label={"google_play_store"}
              >
                <img src={googleplay} alt="googleplay_logo" />
              </a>
              <a
                href={
                  "https://www.microsoft.com/hu-hu/p/prodhost/9plgkbl0ldwm?rtc=1&activetab=pivot:overviewtab"
                }
                rel={"noopener noreferrer"}
                target={"_blank"}
                aria-label={"microsoft_store"}
              >
                <img src={microsoft} alt="microsoft_logo" />
              </a>
            </div>
            <Button
              text={width < 1023 ? <EmailIcon /> : "Feliratkozás a hírlevélre"}
              type={"primary"}
              model={"2"}
              onClick={() => handleOpen()}
            />

            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={open}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <DialogContent className={classes.paper}>
                  <HubspotForm />
                </DialogContent>
              </Fade>
            </Modal>
          </div>

          <div className="footer-data-wrapper">
            <a
              className="footer-data"
              href={`tel:${footer.text_mobile}`}
              target={"_blank"}
              rel="noopener noreferrer"
              aria-label={"phone_number"}
            >
              <span>
                <PhoneIphoneIcon />
              </span>
              <span>{footer.text_mobile}</span>
            </a>

            <a
              className="footer-data"
              href={`https://google.com/maps/place/${footer.text_address
                .split(" ")
                .join("+")}`}
              target={"_blank"}
              rel="noopener noreferrer"
              aria-label={"address"}
            >
              <span>
                <RoomIcon />
              </span>
              <span>{footer.text_address}</span>
            </a>

            <a
              className="footer-data"
              href={`https://${footer.text_facebook}`}
              target={"_blank"}
              rel="noopener noreferrer"
              aria-label={"facebook"}
            >
              <span>
                <FacebookIcon />
              </span>
              <span>facebook</span>
            </a>

            <a
              className="footer-data"
              href={`https://${footer.text_linkedin}`}
              target={"_blank"}
              rel="noopener noreferrer"
              aria-label={"linkedin"}
            >
              <span>
                <LinkedInIcon />
              </span>
              <span>linkedin</span>
            </a>
          </div>
        </>
      ) : null}
    </div>
  )
}

export default Footer
